/**
 * Unit conversion utilities for the FloorplanViewer component
 * Using feet as the primary unit of measurement
 */

// Conversion factors
export const METERS_TO_FEET = 3.28084;
export const FEET_TO_METERS = 0.3048;

/**
 * Format measurement in feet and inches
 * @param {number} feet - Measurement in feet
 * @returns {string} Formatted measurement in feet and inches
 */
export const formatMeasurement = (feet) => {
  // Convert to inches
  const totalInches = feet * 12;
  const wholeFeet = Math.floor(totalInches / 12);
  const inches = Math.round(totalInches % 12);
  
  if (inches === 0) {
    return `${wholeFeet}'`;
  } else if (inches === 12) {
    return `${wholeFeet + 1}'`;
  } else {
    return `${wholeFeet}' ${inches}"`;
  }
};

/**
 * Format area in square feet
 * @param {number} squareFeet - Area in square feet
 * @returns {string} Formatted area in square feet
 */
export const formatArea = (squareFeet) => {
  // Handle invalid inputs
  if (squareFeet === undefined || squareFeet === null || isNaN(squareFeet)) {
    console.warn('Invalid area value:', squareFeet);
    return '0 sqft';
  }
  
  // Ensure positive value
  const positiveArea = Math.max(0, squareFeet);
  
  // Round up to nearest whole square foot
  const roundedSqFt = Math.ceil(positiveArea);
  
  // Format with thousands separators and calculation details
  return `${roundedSqFt.toLocaleString()} sqft\n(${positiveArea.toFixed(2)} sqft)`;
};

/**
 * Get scale display text
 * @param {number} pixelsPerFoot - Scale in pixels per foot
 * @returns {string} Formatted scale text
 */
export const getScaleDisplayText = (pixelsPerFoot) => {
  return `Scale: 1' = ${pixelsPerFoot.toFixed(2)} px`;
};

/**
 * Format a number with comma separators for thousands
 * @param {number} num - The number to format
 * @returns {string} The formatted number string with comma separators
 */
export const formatNumber = (num) => {
  return num.toLocaleString();
}; 